import React from 'react';
import {Link} from 'react-router-dom';
import {FaIcon} from '../../FaIcon';


const CHANNEL_LABELS = {
    GOOGLE_CHANNEL: 'Google',
    FACEBOOK_CHANNEL: 'Meta',
    TIKTOK_CHANNEL: 'TikTok',
    LINKEDIN_CHANNEL: 'LinkedIn',
    ANALYTICS_CHANNEL: 'GA4',
    SHEET_CHANNEL: 'Sheets',
    SHOPIFY_CHANNEL: 'Shopify',
    TIENDA_NUBE_CHANNEL: 'Tiendanube',
};

function formatDate(dateStr, language) {
    if (!dateStr) return '';
    try {
        const date = new Date(dateStr);
        return date.toLocaleDateString(language === 'es' ? 'es-AR' : 'en-US', {
            day: 'numeric', month: 'short', year: 'numeric'
        });
    } catch {
        return dateStr;
    }
}

export function TemplateCard({template, t, language}) {
    return (
        <div className="template-library-card">
            <div className="template-library-card-icon">
                <FaIcon iconName="file-chart-line"/>
            </div>
            <div className="template-library-card-content">
                <h4 className="template-library-card-name">{template.name}</h4>
                {template.description && (
                    <p className="template-library-card-desc">{template.description}</p>
                )}
                {template.source_template_name && (
                    <p className="template-library-card-origin">
                        {t('templates.forked_from', {name: template.source_template_name})}
                    </p>
                )}
                <p className="template-library-card-meta">
                    {t('templates.modified', {date: formatDate(template.updated_on, language)})}
                    {template.created_by && (
                        <> &middot; {t('templates.by_author', {name: template.created_by.name})}</>
                    )}
                </p>
                <div className="template-library-card-badges">
                    {template.required_channels && template.required_channels.map(ch => (
                        <span key={ch} className="template-library-card-channel-badge">
                            {CHANNEL_LABELS[ch] || ch}
                        </span>
                    ))}
                    {template.is_shared && (
                        <span className="template-library-card-shared-badge">
                            <FaIcon iconName="users"/>
                            {t('templates.badge_shared')}
                        </span>
                    )}
                </div>
            </div>
            <div className="template-library-card-action">
                <Link to={`/reports/templates/${template.id}`} className="btn -alt -small">
                    {t('templates.edit')}
                </Link>
            </div>
        </div>
    );
}
